export default __webpack_public_path__ + "static/media/new_people.55c3fb51.jpg";